import ToggleBox from '@/components/Common/ToggleBox';
import { mapActions, mapGetters } from 'vuex';
import sPackage from '@/services/sPackage';

export default {
  name: 'FeatureTile',

  components: { ToggleBox },

  props: {
    service: {
      type: Object,
      default: (() => { })
    },
  },

  data() {
    return {
      arrow: require("@/assets/arrow-up.svg"),
      expanded: false,
    };
  },

  computed: {
    expandLabel() {
      if (this.expanded) {
        return 'Zwiń szczegóły';
      } else {
        return 'Pokaż szczegóły';
      }
    },
    hide_price() {
      return this.service.price <= 0;
    }
  },

  created() {
    this.gb2str = sPackage.gb2str;
  },

  methods: {
    ...mapActions(['getPackageUsage']),
    toggleDescription() {
      this.expanded = !this.expanded;
    },
    showPacketActivation() {
      this.$EventBus.$emit('Service/TOGGLE_MODAL_WITH_STATUS_CHANGE', this.service);
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/Services/FeatureTile/component.js